// extracted by mini-css-extract-plugin
module.exports = {"title":"layout_title__Rvdle","item":"layout_item__Fjlom","pointer":"layout_pointer__abQU6","noPrint":"layout_noPrint__a0h0j"};